<template>
<div class="chapter">
<div class="inner_page">
      ﻿


  <title>The Badass Body Diet: The Breakthrough Diet and Workout for a Tight Booty, Sexy Abs, and Lean Legs</title>
<link href="../styles/9780062390974_template.css" rel="stylesheet" type="text/css"/>
<section epub:type="part" title="PART 1">
<div class="full"><span class="right_1" epub:type="pagebreak" id="page_1" title="1"><img alt="" src="images/partbg.png"/></span></div>
<div class="part">
<p class="PART_NUM"><a href="#/text/nav#p1"><span class="blue2"><span class="bold">PART 1</span></span></a></p>
<p class="PART_line">______________</p>
<p class="PART_TTL"><a href="#/text/nav#p1"><span class="blue"><span class="bold">GET YOUR REAR IN GEAR</span></span></a><span class="right_1" epub:type="pagebreak" id="page_2" title="2"></span></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062390974_P1.vue?085de444